import { render, staticRenderFns } from "./OrderHistoryGrid.vue?vue&type=template&id=6df1b310&"
import script from "./OrderHistoryGrid.vue?vue&type=script&lang=ts&"
export * from "./OrderHistoryGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports